import React, {FC} from 'react';
import {Section} from 'templates/reports/query';
import {parseResult} from 'templates/reports/Section/RegionalComp/parse';

import {Bars} from './Bars';
import {Pies} from './Pies';

import * as styles from './styles.module.scss';

type ChartsProps = {
	data: Section['results'][0]
}

export const Charts: FC<ChartsProps> = ({data}) => {
	const result = parseResult(data);
	return (
		<div className={styles.charts}>
			<Bars metric='fat' result={result} />
			<Bars metric='lean' result={result} />
			<Pies metric='total' result={result} />
			<Pies metric='fat' result={result} />
			<Pies metric='lean' result={result} />
			<Pies metric='bone' result={result} />
		</div>
	);
};
